module.exports = __webpack_public_path__ + "static/media/demontford.47e43161.webp";